module.exports = __webpack_public_path__ + "static/media/SharpSans-Semibold.2eab6f4f.woff";